// copy from https://overreacted.io/making-setinterval-declarative-with-react-hooks/

import { useEffect, useRef } from 'react';

type IntervalCallback = () => void;

export const useInterval = (
    callback: IntervalCallback,
    delay: number | null
) => {
    const savedCallback = useRef<IntervalCallback | null>(null);

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current?.();
        }
        if (delay === null) {
            return undefined;
        }
        const id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
};
